export default "__VITE_PUBLIC_ASSET__cb6f0406__"